/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { UserInterviewRegistration } from "../../models/user-interview-registration";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface RegisterForUserInterview$Params {
  body: UserInterviewRegistration;
}

export function registerForUserInterview(
  http: HttpClient,
  rootUrl: string,
  params: RegisterForUserInterview$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<null>> {
  const rb = new RequestBuilder(rootUrl, registerForUserInterview.PATH, "post");
  if (params) {
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<null>;
    }),
  );
}

registerForUserInterview.PATH = "/dashboard/user/interview-registration";
